import { Api } from "./api.service";

export function getCategoryStat(type) {
  return Api.get(`/category/${type}/stat`);
}

export function getIdentifiersStat() {
  return Api.get(`/identifier/stat`);
}
